import { proxy } from 'valtio';

type State = {
  [collectionId: string]: string[];
};

// In it's own file so it survives hot reload
export const store = proxy<State>({});

export const actions = {
  reset(collectionId: string): void {
    store[collectionId] = [];
  },
};
